import { Hero } from "../components/Hero";
import { Values } from "../components/Values";
import { Certification } from "../components/Certification";
import { Standard } from "../components/Standard";
import { Benefits } from "../components/Benefits";
import { EuipoTrademark } from "../components/EuipoTrademark";
import { HallOfFame } from "../components/HallOfFame";
import { DocumentsDownload } from "../components/DocumentsDownload";
import { Contact } from "../components/Contact";
import { useLang } from "../context/LanguageContext";

export default function Home() {
  const { t } = useLang();
  return (
    <>
      <Hero t={t} />
      <Values t={t} />
      <Certification t={t} />
      <Standard t={t} />
      <Benefits t={t} />
      <EuipoTrademark />
      <HallOfFame />
      <DocumentsDownload />
      <Contact />
    </>
  );
}
